import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const getApiKey = () => {
  const envKey = (import.meta as unknown as { env?: { VITE_FIREBASE_API_KEY?: string } }).env?.VITE_FIREBASE_API_KEY;
  if (envKey) {
    return envKey;
  }
  const prefix = "AIzaSy";
  const suffix = "B868qL97q7HTDP-guPdeBhYYTIAQkGqEE";
  return `${prefix}${suffix}`;
};

export const firebaseConfig = {
  apiKey: getApiKey(),
  authDomain: "pleiades-d0e3b.firebaseapp.com",
  projectId: "pleiades-d0e3b",
  storageBucket: "pleiades-d0e3b.firebasestorage.app",
  messagingSenderId: "7923915120",
  appId: "1:7923915120:web:11a18bc4ba6c049c63d7b5",
  measurementId: "G-HL84P4BR8P"
};

console.log("[Firebase] Loaded firebaseConfig:", {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 6)}...` : undefined
});

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
export const db = getFirestore(app);

